module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Brush-0c1b96aee4eea8bde15a96ae0c17e3a1.svg";